import './scss/index.scss'
import {PaginationComponent} from './PaginationComponent'

const PaginationPackage = {
    name: 'UIPagination',
    configure: function (config) {
        config.addComponent('UIPagination', PaginationComponent)
    }
}

export {PaginationPackage}
